<div
  class="container"
  [class.local]="local">
  <app-turbine
    speed="fast"
    [contrast]="contrast"></app-turbine>
  <app-turbine
    [text]="true"
    [contrast]="contrast"></app-turbine>
  <app-turbine
    speed="slow"
    [contrast]="contrast"></app-turbine>
</div>
